/**
 * Base URL for the auth service (no trailing slash).
 * Override: REACT_APP_AUTH_URL (required outside local CRA).
 */
export function getAuthBaseUrl() {
  const fromEnv = process.env.REACT_APP_AUTH_URL;
  if (fromEnv && fromEnv.trim()) {
    return fromEnv.replace(/\/+$/, '');
  }
  return 'http://localhost:8080';
}

/** @param {string} path e.g. `/login/google` */
export function authUrl(path) {
  const base = getAuthBaseUrl();
  const p = path.startsWith('/') ? path : `/${path}`;
  return `${base}${p}`;
}
